<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="90px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="企业名称" prop="tenantFullName">
            <el-input v-model="queryParams.tenantFullName" placeholder="请输入企业名称" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="入驻平台" prop="tenantFlag">
            <el-select
              v-model="queryParams.tenantFlag"
              placeholder="请选择"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in flagOptions"
                :key="dict.code"
                :label="dict.name"
                :value="dict.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="12">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" @click="handleAdd">添加</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="企业名称" min-width="200" align="center" prop="tenantFullName" />
      <el-table-column label="LOGO" min-width="200" align="center" prop="tenantFullName">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.companyLogo"
            style="width: 100px; height: 100px"
            :src="scope.row.companyLogo"
            fit="fill"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="联系人" min-width="140" align="center" prop="linkNickName" />
      <el-table-column label="联系人手机号" min-width="120" align="center" prop="linkTel" />
      <el-table-column label="入驻平台" min-width="140" align="center" prop="packageName">
       <template slot-scope="scope">
         {{scope.row.tenantFlag === 0 ?'否' : '是'}}
       </template>
      </el-table-column>
      <el-table-column label="添加时间" min-width="200" align="center" prop="createTime" />
      <el-table-column label="操作" min-width="150" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
    <AddMemberDialog ref="addMemberDialogRef" @success="getList"></AddMemberDialog>
  </div>
</template>

<script>
import { queryMemberList, deleteTenantMember } from "@/api/system/tenant";
import { amountFormat } from "@/utils/index";
import AddMemberDialog from "./components/addMemberDialog.vue";

export default {
  name: "BusinessList",
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      data: {
        startDate: "",
        endDate: ""
      },
      flagOptions: [{
        code: '0',
        name: '否'
      },{
        code: '1',
        name: '是'
      }],
      packageOptions: [],
      total: 1,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        validityStartTime: "",
        validityEndTime: "",
        packageId: null,
        linkNickName: null,
        tenantFullName: null,
        linkTel: null
      },
      dataList: [
        {
          name: "一体化设备",
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          type: 2,
          typeDesc: "图文",
          status: 1,
          statusDesc: "已上线",
          updateTime: "2021.03.01 12:12:12"
        }
      ],
      amountFormat
    };
  },
  created() {
    this.queryList();
  },
  components: {
    AddMemberDialog
  },
  methods: {
    // 跳转套餐详情
    goPackageDetail(row) {
      this.$router.push(`/saas/package/detail?packageId=${row.packageId}`)
    },
    // 跳转企业详情
    handleSee (row) {
      this.$router.push(`/saas/tenant/detail?id=${row.tenantId}`)
    },
    handleAdd() {
      this.$refs.addMemberDialogRef.open();
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      // resetForm不生效
      this.queryParams.userId = null;
      this.handleQuery();
    },
    handleAddText() {
      this.$refs.addTextDialogRef.open();
    },
    getList() {
      this.queryParams.pageNum = 1;
      this.queryList();
    },
    queryList() {
      this.loading = true;
      queryMemberList(this.queryParams)
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total;
        })
        .catch(error => {
          this.loading = false;
        });
    },

    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.id);
    },
    // 启用时间
    changeValidityStart(e) {
      if (e) {
        this.queryParams.validityStartTimeStart = e[0];
        this.queryParams.validityStartTimeEnd = e[1];
      } else {
        this.queryParams.validityStartTimeStart = "";
        this.queryParams.validityStartTimeEnd = "";
      }
    },
    // 到期时间
    changeValidityEnd(e) {
      if (e) {
        this.queryParams.validityEndTimeStart = e[0];
        this.queryParams.validityEndTimeEnd = e[1];
      } else {
        this.queryParams.validityEndTimeStart = "";
        this.queryParams.validityEndTimeEnd = "";
      }
    },
    handleDelete(row) {
      let _this = this
      this.$confirm('请确认是否移除该企业', "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
      }).then(() => {
          const loading = _this.$loading({
              lock: true,
              text: '加载中',
              spinner: 'el-icon-loading'
          });
          deleteTenantMember({
              id: row.id
          }).then(response => {
              _this.$message.success('删除成功')
              _this.queryList();
              loading.close();
          }).catch(error => {
              loading.close();
          });

      })
    },
    handleEdit(row) {
      this.$refs.addMemberDialogRef.open(JSON.parse(JSON.stringify(row)), 'edit');
    },
  }
};
</script>
